import * as Msal from "msal";
import { cookieService } from "./CookieService";

class AuthService {

    private msalInstance: Msal.UserAgentApplication;
    private request: Msal.AuthenticationParameters;

    public constructor() {
        const msalConfig: Msal.Configuration = {
            auth: {
                clientId: process.env.VUE_APP_AZURE_AD_CLIENTID,
                authority: `${process.env.VUE_APP_AZURE_AD_INSTANCE}/${process.env.VUE_APP_AZURE_AD_TENANTID}`,
                redirectUri: `${window.location.origin}${process.env.VUE_APP_AZURE_AD_CALLBACKPATH}`,
                navigateToLoginRequestUrl: false,
            },
            cache: {
                cacheLocation: "localStorage",
                storeAuthStateInCookie: true,
            },
        };
        this.request = {
            scopes: [
                msalConfig.auth.clientId,
            ],
        };
        this.msalInstance = new Msal.UserAgentApplication(msalConfig);
        this.msalInstance.handleRedirectCallback((error, response) => {
            if (!error) {
                this.msalInstance.acquireTokenSilent(this.request);
            }
        });
    }

    public login(): void {
        if (this.msalInstance) {
            this.msalInstance.loginRedirect(this.request);
        }
    }

    public logout(): void {
        if (this.msalInstance) {
            this.msalInstance.logout();
        }
    }

    public getAccount(): Msal.Account {
        if (this.msalInstance) {
            return this.msalInstance.getAccount();
        }
        return null;
    }

    public getAccessToken(): Promise<string> {
        return new Promise((resolve, reject) => {
            this.msalInstance.acquireTokenSilent(this.request).then((response: Msal.AuthResponse) => {
                if (response?.accessToken !== null) {
                    resolve(response.accessToken);
                } else {
                    cookieService.setCookie("exp.source", window.location.pathname, 300);
                    this.msalInstance.acquireTokenRedirect(this.request);
                }
            }).catch(reason => {
                cookieService.setCookie("exp.source", window.location.pathname, 300);
                this.msalInstance.acquireTokenRedirect(this.request);
            });
        });
    }
}

const authService = new AuthService();

export { AuthService, authService };
